import React from 'react';
import { ChatMessage } from './ChatMessage';
import { ChatDateHeader } from './ChatDateHeader';

interface Message {
  id: number;
  sender_type: 'user' | 'bot';
  message: string;
  timestamp_msk: string;
  template_key?: string;
  template_params?: string;
  message_type?: string;
}

interface ChatMessageGroupProps {
  date: string;
  messages: Message[];
  botDisplayName: string;
  botName?: string;
}

export const ChatMessageGroup: React.FC<ChatMessageGroupProps> = ({ 
  date, 
  messages, 
  botDisplayName,
  botName
}) => {
  return (
    <div className="chat-message-group">
      <ChatDateHeader date={date} />
      {messages.map((message) => (
        <ChatMessage
          key={message.id}
          message={message}
          botDisplayName={botDisplayName}
          botName={botName}
        />
      ))}
    </div>
  );
}; 